import { Suspense } from 'react';
import { Spinner } from '@quickmd-llc/design-system';

export function FullScreenLoader() {
  return (
    <div className="flex h-dvh items-center justify-center overflow-auto bg-app-background">
      <Spinner iconSize="xxl" className="animate-spin text-text-dark" />
    </div>
  );
}

type Props = {
  children: React.ReactNode;
};

export default function SuspenseLoader({ children }: Props) {
  return <Suspense fallback={<FullScreenLoader />}>{children}</Suspense>;
}
